import {CoinsSections_Levels} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import React from 'react';
import {ClaimCoinsButton} from '../ClaimCoins/ClaimCoinsButton';
import {CoinsLevelSlider} from './CoinsLevelSlider';

export const CoinsLevels: React.FC<CoinsSections_Levels> = ({title, type}) => {
  switch (type?.$case) {
    case 'bonusToClaim':
      return <ClaimCoinsButton bonusToClaim={type.bonusToClaim} />;
    case 'slider':
      return <CoinsLevelSlider title={title} levels={type.slider.levels} />;
    default:
      return null;
  }
};
